import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

export const UnderlyingHistoSkeleton: FC = () => (
  <div className="m-3">
    <Skeleton width="70em" height="40em" />
  </div>
);
